const BillingQueueRoute = {
  path: '/accounting/BillingQueue',
  load: () => import('./BillingQueue'),
  protected: true,
};

export { BillingQueueRoute };
